const ROOT = '/'

export default {
  COOKIES_PAGE: ROOT + 'cookies',
  TERMS_AND_CONDITIONS_PAGE: ROOT + 'conditions-generales',
} as const
